"use strict";

import angular from "angular";
import ApprovedProjectsController from "./controller/approvedProjects";
import FinalizationProjectsController from "./controller/finalizationProjects";
import ProjectController from "./controller/project";
import ProjectModalCreateController from "./controller/projectModalCreate";
import ProjectModalNotifyController from "./controller/projectModalNotify";
import ProjectsController from "./controller/projects";
import ProjectsTrashController from "./controller/projects-trash";
import RejectedProjectsController from "./controller/rejectedProjects";
import ReviewedProjectsController from "./controller/reviewedProjects";
import ProjectFilterDirective from "./directive/projectFilter";
import ProjectFilterIndicatorDirective from "./directive/projectFilterIndicator";
import ProjectTabInvestActivityDirective from "./directive/projectInvestActivity";
import ProjectPhaseProgressDirective from "./directive/projectProgress";
import ProjectTabAttachmentsDirective from "./directive/projectTabAttachments";
import ProjectTabCommonDirective from "./directive/projectTabCommon";
import ProjectTabFundsDirective from "./directive/projectTabFunds";
import ProjectTabHistoryDirective from "./directive/projectTabHistory";
import ProjectTabLandsDirective from "./directive/projectTabLands";
import ProjectTabMaintenancesDirective from "./directive/projectTabMaintanences";
import ProjectTabProgressDirective from "./directive/projectTabProgress";
import ProjectsTabQuestionsDirective from "./directive/projectTabQuestions";
import ProjectTabReadinessDirective from "./directive/projectTabReadiness";
import ProjectTableDirective from "./directive/projectTable";
import ProjectTeamDirective from "./directive/projectTeam";
import ProjectsTrashTableDirective from "./directive/projectsTrashTable";
import TransactionFilterDirective from "./module/transaction/directive/transactionFilter";

import chronology from "./module/chronology";
import contact from "./module/contact";
import fund from "./module/fund";
import investorCountry from "./module/investor_country";
import land from "./module/land";
import maintenance from "./module/maintenance";
import maintenanceKind from "./module/maintenance_kind";
import okved from "./module/okved";
import output from "./module/output";
import progress from "./module/progress";
import quarter from "./module/quarter";
import support from "./module/support";
import tax from "./module/tax";
import transaction from "./module/transaction";
import workPlace from "./module/work_place";
import ProjectService from "./service/project";
import ProjectUtilsService from "./service/utils";

/**
 * @author Maxim Seredkin
 */
export default angular
  .module("investmentProject.project", [
    contact,
    fund,
    investorCountry,
    land,
    maintenance,
    maintenanceKind,
    okved,
    output,
    quarter,
    support,
    progress,
    transaction,
    tax,
    workPlace,
    chronology,
  ])
  // контроллеры
  .controller("ProjectController", ProjectController)
  .controller("ProjectsController", ProjectsController)
  .controller("ApprovedProjectRequestsController", ApprovedProjectsController)
  .controller("ReviewedProjectRequestsController", ReviewedProjectsController)
  .controller("RejectedProjectRequestsController", RejectedProjectsController)
  .controller(
    "FinalizationProjectRequestsController",
    FinalizationProjectsController
  )
  .controller("ProjectModalCreateController", ProjectModalCreateController)
  .controller("ProjectModalNotifyController", ProjectModalNotifyController)
  .controller("ProjectsTrashController", ProjectsTrashController)
  // директивы
  .directive("projectTabCommon", ProjectTabCommonDirective)
  .directive("projectTabFunds", ProjectTabFundsDirective)
  .directive("projectTabProgress", ProjectTabProgressDirective)
  .directive("projectTabMaintenances", ProjectTabMaintenancesDirective)
  .directive("projectTabLands", ProjectTabLandsDirective)
  .directive("projectTabReadiness", ProjectTabReadinessDirective)
  .directive("projectTabAttachments", ProjectTabAttachmentsDirective)
  .directive("projectTabQuestions", ProjectsTabQuestionsDirective)
  .directive("projectTable", ProjectTableDirective)
  .directive("projectTeam", ProjectTeamDirective)
  .directive("projectFilter", ProjectFilterDirective)
  .directive("projectFilterIndicator", ProjectFilterIndicatorDirective)
  .directive("projectPhaseProgress", ProjectPhaseProgressDirective)
  .directive("projectsTrashTable", ProjectsTrashTableDirective)
  .directive("projectTabHistory", ProjectTabHistoryDirective)
  .directive("projectTabInvestActivity", ProjectTabInvestActivityDirective)
  .directive("transactionFilter", TransactionFilterDirective)
  // сервисы
  .factory("ProjectService", ProjectService)
  .factory("ProjectUtils", ProjectUtilsService).name;
